const routes = {
	'/merchant-home': '商户主页',
	'/merchant-home/details': '商户详情',
	'/merchant-home/recharge': '充值',
	'/merchant-home/withdraw': '提现',
	'/merchant-home/setting-phone': '绑定手机号',
	'/merchant-home/business-setting/integral-rule': '积分规则',
	'/merchant-home/business-setting/payment-code': '商户收款码',
	'/merchant-home/business-setting/fee-setting': '手续费设置',
};

export {
	routes,
};
